import { RequestTypes } from "@/api/interfaces/AdvantageCardRequest";
import ButtonComponent from "@/components/ButtonComponent/ButtonComponent";
import styles from "./GetTheApp.module.scss";

const TextButton = (
  <ButtonComponent
    buttonText={"TEXT"}
    requestType={RequestTypes.text}
    iconName={"message-dots"}
    className={"caprx-icon-messages-bubble"}
    testId="request-card-text-button"
  />
);
const EmailButton = (
  <ButtonComponent
    buttonText={"EMAIL"}
    requestType={RequestTypes.email}
    iconName={"envelope"}
    className={"caprx-icon-mail-letter"}
    testId="request-card-email-button"
  />
);
const PrintButton = (
  <ButtonComponent
    buttonText={"PRINT"}
    requestType={RequestTypes.print}
    iconName={"print"}
    className={"caprx-icon-print"}
    testId="request-card-print-button"
  />
);

const GetTheApp: React.FC = () => {
  return (
    <div data-testid="get-the-app-container">
      <div className={styles.SecondText} data-testid="get-the-app-container-text">
        Download your free virtual card to unlock discounts:
      </div>
      <div className={styles.ButtonAlignment}>
        {TextButton}
        {EmailButton}
        {PrintButton}
      </div>
    </div>
  );
};

export default GetTheApp;
